import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { RootState } from '@share/utils';
import { ILoginState, IMenuState } from '@share/store/slices';
import { BlueButton } from '@share/components';
import { MY_VC_ACCOUNT_LINK } from '@constants';
import { RENEWAL_AGENCY_EXCLUDE_RENEWAL, RENEWAL_AGENCY_INCLUDE_RENEWAL } from '@share/constants';
import { isEmpty } from 'lodash';

import './style.scss';

interface IMapStateToProps {
  menuStore: IMenuState;
	loginStore: ILoginState;
}

interface IProps extends IMapStateToProps {}

class MembershipComponent extends React.Component<IProps> {
  render(): React.ReactNode {
    const { menuStore, loginStore } = this.props;
    const { account } = loginStore;

    const renewalAgency = menuStore?.items?.renewalAgency as string;
    const isRenewalMember = RENEWAL_AGENCY_INCLUDE_RENEWAL.includes(renewalAgency) && !RENEWAL_AGENCY_EXCLUDE_RENEWAL.includes(renewalAgency);
  
    if (!isRenewalMember) {
      return null;
    }

    const mainBackgroundColor = account?.mainBackgroundColor;
    const style = !isEmpty(mainBackgroundColor) ? { background: mainBackgroundColor } : {};

    return (
      <div className="membership" style={style}>
        <div className="membership__wrapper">
          <div className="membership__text">
            <p className="membership__title">
              <FormattedMessage id="renew.my.membership" />
            </p>
            <p className="membership__description">
              <FormattedMessage id="need.to.book.trip.and.think.my.membership.expired" />
            </p>
          </div>
          <a
            href={MY_VC_ACCOUNT_LINK}
            className="membership__btn-wrapper"
            target="_blank"
            rel="noreferrer"
          >
            <BlueButton reverse>
              <FormattedMessage id="renew.membership" />
            </BlueButton>
          </a>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    menuStore: state.navigationMenuStore,
    loginStore: state.loginStore
  };
};

export const Membership = connect(mapStateToProps)(MembershipComponent);
